import { SectionDown } from './section-down'
import styles from './screen-state.module.css'

type Props = {
  error: unknown
  onRetry?: () => void
}

let signIn: () => void = () => window.location.reload()

export function configureSignIn(handler: () => void): void {
  signIn = handler
}

export function errorStatus(error: unknown): number | null {
  if (typeof error !== 'object' || error === null || !('status' in error)) return null
  return typeof error.status === 'number' ? error.status : null
}

export function isClientError(error: unknown): boolean {
  const status = errorStatus(error)
  return status !== null && status >= 400 && status < 500
}

export function retryUnlessClientError(failureCount: number, error: unknown): boolean {
  return !isClientError(error) && failureCount < 1
}

export function QueryError({ error, onRetry = () => window.location.reload() }: Props) {
  const status = errorStatus(error)
  if (status === 401) {
    return (
      <ScreenState
        title="Нужно войти"
        text="Сессия закончилась или вы ещё не вошли. Войдите, чтобы открыть этот раздел."
        action={{ label: 'Войти', onClick: () => signIn() }}
      />
    )
  }
  if (status === 403 || status === 404) {
    return (
      <ScreenState
        title={status === 404 ? 'Здесь ничего нет' : 'Нет доступа'}
        text={status === 404 ? 'Возможно, ссылка устарела.' : 'Этот раздел недоступен для вашего аккаунта.'}
        action={{ label: 'На главную', onClick: () => window.location.assign('/') }}
      />
    )
  }
  if (status !== null && status >= 400 && status < 500) {
    return <ScreenState title="Не получилось открыть раздел" action={{ label: 'Повторить', onClick: onRetry }} />
  }
  return <SectionDown onRetry={onRetry} />
}

function ScreenState({ title, text, action }: { title: string; text?: string; action: { label: string; onClick: () => void } }) {
  return (
    <div className={styles.state} role="status">
      <h2 className={styles.title}>{title}</h2>
      {text ? <p className={styles.text}>{text}</p> : null}
      <button type="button" className={styles.btn} onClick={action.onClick}>
        {action.label}
      </button>
    </div>
  )
}
